export default __webpack_public_path__ + "static/media/money.d5372a35.svg";